import React from 'react';
import { translate } from "react-translate";
import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import Map from './map/map';
import { Row, Col } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

class ContactPage extends React.Component {

  render() {
    return (
      <div>
        <Navbar commonProps={this.props.commonProps} />
        <Map title="Deamed" height={300} src="https://maps.google.com/maps?q=%E1%83%93%E1%83%94%E1%83%90%E1%83%9B%E1%83%94%E1%83%93%E1%83%98&amp;t=m&amp;z=17&amp;output=embed&amp;iwloc=near" />
        <div className="contactInfoC">
          <div className="contactInfo">
            <Row>
              <Col sm={4}>
                <div><FaMapMarkerAlt color="#25b6ea" size="60" /></div>
                <div className="title capsFont">{ this.props.t('address') }</div>
                <div className="body bodyFont">{ this.props.t('address_body') }</div>
              </Col>
              <Col sm={4}>
                <div><FaPhone color="#25b6ea" size="60" /></div>
                <div className="title capsFont">{ this.props.t('phone') }</div>
                <div className="body bodyFont">{ this.props.t('phone_body') }</div>
              </Col>
              <Col sm={4}>
                <div><FaEnvelope color="#25b6ea" size="60" /></div>
                <div className="title capsFont">{ this.props.t('email') }</div>
                <div className="body bodyFont">{ this.props.t('email_body') }</div>
              </Col>
            </Row>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

}

export default translate('ContactPage')(ContactPage);
